import React from 'react';
import { Viewer, Worker } from '@react-pdf-viewer/core';
import { defaultLayoutPlugin } from '@react-pdf-viewer/default-layout'
import '@react-pdf-viewer/core/lib/styles/index.css';
import '@react-pdf-viewer/default-layout/lib/styles/index.css';
import { hostName } from '../../requestMethods';

interface props {
  modal: boolean,
  toggle: any,
  selectedFile: any
}

const ShowselectedFileImage: React.FC<props> = ({ modal, toggle, selectedFile }) => {
  const newplugin = defaultLayoutPlugin()

  return (
    <div>
      {modal && (
        <>
          <div className="fixed inset-0 z-10 overflow-y-auto">
            <div
              className="fixed inset-0 w-full h-full bg-black opacity-40"
              onClick={toggle}
            ></div>
            <div className="flex items-center min-h-screen px-4 py-8">
              <div className="relative w-full max-w-lg p-4 mx-auto bg-white rounded-md shadow-lg">
                <div className="mt-3">
                <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.4.120/build/pdf.worker.min.js">
                    {selectedFile && 
                      <Viewer fileUrl={hostName + "files/legalAndRegTexts/"  + selectedFile} plugins={[newplugin]} />
                    }
                    {!selectedFile && <b>No pdf</b>}
                  </Worker>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
}

export default ShowselectedFileImage
